import { render, staticRenderFns } from "./HomejsData.vue?vue&type=template&id=4f738c26&scoped=true"
import script from "./HomejsData.vue?vue&type=script&lang=js"
export * from "./HomejsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f738c26",
  null
  
)

export default component.exports